// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { PageConfig, URLExt } from '@jupyterlab/coreutils';
import { IKernelSpecs } from '@jupyterlite/kernel';
import { JavaScriptKernel } from '@jupyterlite/javascript-kernel';
/**
 * A plugin to register the JavaScript kernel.
 */
const kernel = {
    id: '@jupyterlite/javascript-kernel-extension:kernel',
    autoStart: true,
    requires: [IKernelSpecs],
    activate: (app, kernelspecs) => {
        const baseUrl = PageConfig.getBaseUrl();
        kernelspecs.register({
            spec: {
                name: 'javascript',
                display_name: 'JavaScript',
                language: 'javascript',
                argv: [],
                spec: {
                    argv: [],
                    env: {},
                    display_name: 'JavaScript',
                    language: 'javascript',
                    interrupt_mode: 'message',
                    metadata: {},
                },
                resources: {
                    'logo-32x32': '',
                    'logo-64x64': URLExt.join(baseUrl, '/kernelspecs/javascript.svg'),
                },
            },
            create: async (options) => {
                return new JavaScriptKernel(options);
            },
        });
    },
};
const plugins = [kernel];
export default plugins;
